import { Injectable } from '@angular/core';

import { doc, docData, collection, collectionData, Firestore, query, orderBy, where, limit, addDoc, updateDoc, deleteDoc, setDoc, deleteField, getDocs, collectionGroup, writeBatch, startAfter } from '@angular/fire/firestore';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { GameObject, ObjectType } from '../classes/index';

@Injectable()
export class ObjectService {

	constructor(private firestore: Firestore) {
	}

	listObjectTypes() {
		return collectionData(query(collection(this.firestore, 'object_types'), orderBy('orderNum')), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(data => {
				let object = new ObjectType();
				object.fromJSON(data);
				return object;
			});
		}));	
	}

	listObjectsByObjectTypes(collectionPath, objectTypeId) {
		return collectionData(query(collection(this.firestore, collectionPath), where("objectTypeId", "==", objectTypeId)), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(data => {
				delete data.collectionPath;
				let object = new GameObject(collectionPath);
				object.fromJSON(data);
				return object;
			});
		}))
		.pipe(map(objects => objects.sort((a, b) => {
			if (a.labels['fr'] > b.labels['fr']) return 1;
			else if (a.labels['fr'] < b.labels['fr']) return -1;
			else return 0;
		})));
	}

	listAllGameObjectsByObjectTypes(objectTypeId) {
		return collectionData(query(collectionGroup(this.firestore, 'objects'), where("scope", "==", 'game'), where("objectTypeId", "==", objectTypeId)), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(data => {
				let object = new GameObject(`games/${data.gameId}/objects`);
				object.fromJSON(data);
				return object;
			});
		}));
	}

	listObjects(collectionPath) {
		return collectionData(query(collection(this.firestore, collectionPath)), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(data => {
				delete data.collectionPath;
				let object = new GameObject(collectionPath);
				object.fromJSON(data);
				return object;
			});
		}))
		.pipe(map(objects => objects.sort((a, b) => {
			if (a.labels['fr'] > b.labels['fr']) return 1;
			else if (a.labels['fr'] < b.labels['fr']) return -1;
			else return 0;
		})));
	}

	getObjects(collectionPath){
		return collectionData(query(collection(this.firestore, collectionPath), orderBy('orderNum', 'asc')), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(data => {
				let object = new GameObject(collectionPath);
				object.fromJSON(data);
				return object;
			});
		}));
	}

	//temp fix for team objects not having orderNum set
	getJournalObjects(collectionPath){
		return collectionData(query(collection(this.firestore, collectionPath), orderBy('activeTime', 'asc')), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(data => {
				let object = new GameObject(collectionPath);
				object.fromJSON(data);
				return object;
			});
		}));
	}

	addObject(object) {
		let data = { ...object };
		delete data.collectionPath;
		return addDoc(collection(this.firestore, object.collectionPath), {...data});
	}

	setObject(object) {
		let data = { ...object };
		delete data.collectionPath;
		return setDoc(doc(this.firestore, object.collectionPath, object.id), data);
	}

	async updateAllObject(templateObjects){
		var batch = writeBatch(this.firestore);
		for(let j = 0; j < templateObjects.length; j++){
			let objectsGames = templateObjects[j].changes
			for(let i = 0; i < objectsGames.length; i++){
				templateObjects[j].collectionPath = deleteField();
				batch.update(doc(this.firestore, objectsGames[i].collectionPath, objectsGames[i].id),
					{labels:templateObjects[j].labels, description:templateObjects[j].description, pictureLastUpdate: templateObjects[j].pictureLastUpdate})				
			}
		}
		await batch.commit();	
	}

	updateObject(object, data){
		data.collectionPath = deleteField();
		console.log('Update object:'+object.collectionPath+'/'+object.id);
		console.log('DATA:'+JSON.stringify(data));
		return updateDoc(doc(this.firestore, object.collectionPath, object.id), data);
	}

	deleteObject(object) {
		return deleteDoc(doc(this.firestore, object.collectionPath, object.id));
	}

	initPlayObjects(gameId, playId) {
		return Observable.create(async (observer) => {
			console.log('get objects from game:'+gameId);
			getDocs(collection(this.firestore, `games/${gameId}/objects`))
			.then(async (snapshot) => {
				const objects = snapshot.docs.map(doc => {
					const data = doc.data() as GameObject;
					data.id = doc.id;
					return data;
				});
				
				for(let object of objects){
					console.log('Init play object:'+object.name);
					await this.addPlayObject(playId, object.id, object);
				}
				observer.next();
			});
		});
	}

	addPlayObject(playId, objectId, data) {
		//game.creationDate = firebase.firestore.FieldValue.serverTimestamp()
		return setDoc(doc(this.firestore, `plays/${playId}/objects/${objectId}`), { ...data });
	}
}

